import MapPlaceAutocompleteFilter from './PlaceAutocompleteFilter'

export default function CityFilter({
  filterCity,
  filterState,
  updateFilter,
}: {
  filterCity: string[]
  filterState: string[]
  updateFilter: (updates: Record<string, any>) => void
}) {
  return (
    <MapPlaceAutocompleteFilter
      label="City"
      searchType="city"
      placeholder="Search cities..."
      selectedValues={filterCity}
      allowedStates={filterState}
      filterKey="cities"
      updateFilter={updateFilter}
    />
  )
}
